/**
 * Reações permitidas — espelho de `functions/messaging/reacoes.js`.
 *
 * Duplicado de propósito, pelo mesmo motivo do `telefone.js`: o deploy das
 * Functions empacota só a pasta `functions/`, então um import atravessando a
 * fronteira passaria localmente e quebraria no deploy.
 *
 * **As duas listas têm de ser iguais.** Se divergirem, a paleta oferece um
 * emoji que o servidor recusa com `invalid-argument`, e o atendente leva um erro
 * sem causa visível. Há teste comparando as duas.
 */
export const EMOJIS_REACAO = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
